import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sms-balance',
  templateUrl: './sms-balance.component.html',
  styleUrls: ['./sms-balance.component.css']
})
export class SmsBalanceComponent implements OnInit {

  constructor(private router:Router) { }
 
  ngOnInit() {
    // var url = 'http://sms365trans.jdaas.com';  
    // window.open(url);     
  }

}
